import WithAuth from './withAuth.js';
export default WithAuth;
